<template>
  <div class="cooperativeEcosystem">
    <header>
      <OssImg class="headerImg" src="/UIV3/ecosystem1.png" alt="" />
      <div class="headerTitle">YAOKEIOT合作伙伴联盟</div>
      <div class="btn" @click="navTo('/consult')">立即加入</div>
    </header>
    <main>
      <div class="title">合作伙伴体系</div>
      <div class="topIcons">
        <div class="iconItem" v-for="(item, index) in MAIN_ICONS" :key="index">
          <div class="iconImg" :style="{
            backgroundColor: item.color,
          }">
            <OssImg class="IconIcon" :src="item.imgPath" alt="" />
          </div>
          <div class="iconTitle">{{ item.title }}</div>
          <div class="iconContent">{{ item.desc }}</div>
        </div>
      </div>
    </main>
    <footer>
      <div class="inner">
        <div class="title">合作伙伴</div>
        <div class="friends">
          <div class="friendItem" v-for="(item, index) in COMPANY_LIST" :key="index">
            <el-card shadow="hover">
              <template #default>
                <div class="f-img">
                  <img class="friendImg" :src="item.imgPath" fit="contain" />
                </div>
                <div class="f-title">{{ item.name }}</div>
                <div class="f-desc">
                  {{ item.desc }}
                </div>
              </template>
            </el-card>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { navTo } from "@/utils/util";
import { ref } from "vue";
const MAIN_ICONS = ref([
  {
    imgPath: "images/cooperativeEcosystem/icon7.png",
    color: "#e6f5ff",
    title: "战略合作",
    desc: "构建安全管理生态，能帮助实验室满足合规要求，避免因违规面临处罚、停业整顿等后果，保障机构合法运营",
  },
  {
    imgPath: "images/cooperativeEcosystem/icon8.png",
    color: "#efeeff",
    title: "渠道合作",
    desc: "提供完整的生命周期解决方案，灵活合作方式,协同提供定制化解决方案,实现合作双方的互利共赢与业务增长",
  },
  {
    imgPath: "images/cooperativeEcosystem/icon9.png",
    color: "#e6f5ff",
    title: "产学研合作",
    desc: "对技术需求设立研究课题，联合推动产学研深度合作，参与人才培养",
  },
]);
const COMPANY_LIST = ref([
  {
    name: "海康威视技术有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company1.webp"),
    desc: "海康威视成立于 2001年，是聚焦技术创新的科技企业。以视频技术为基，构建起物联感知、人工智能、大数据的智能物联技术体系。产品与服务广泛应用于全球超150 个国家和地区，助力千行百业，引领智能物联新未来。",
  },
  {
    name: "杭州迪普科技股份有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company2.webp"),
    desc: "杭州迪普科技股份有限公司成立于 2008 年,公司以 “让网络更简单、智能、安全” 为使命，聚焦网络安全及应用交付领域。拥有专业研发团队，构建全面产品体系，专利众多。用户覆盖多行业，承担重大活动网络安保，持续创新，为客户提供优质方案与服务。",
  },
  {
    name: "湖北九州医药供应链有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company3.webp"),
    desc: "湖北九州医药供应链有限公司于 2023 年 10 月成立，公司打造 “1＋5＋N＋X” 架构平台，集纳上下游主体信息，提供采购分销等一站式方案。已吸引 3.5 万多家企业 “入链”，智慧物流覆盖全国 96％地区，交易额突破 100 亿元。",
  },
  {
    name: "内蒙古元乙科技有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company4.webp"),
    desc: "内蒙古元乙科技有限公司于 2003 年成立，是专注科技推广与应用服务的企业，注册资本 5006 万元。公司具备多项资质，业务多元，涵盖软硬件销售、开发、系统集成等。作为高新技术企业，服务政府、教育等多领域，凭专业实力提供优质方案。",
  },
  {
    name: "北京伊诺凯科技有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company5.webp"),
    desc: "伊诺凯拥有资深国际化管理团队，打造综合性科研采购平台，产品涵盖化学试剂、医药中间体、分析标准品、生命科学试剂及实验室耗材。作为多家国际顶尖品牌授权代理商，整合全球 2600 余个合作品牌，产品线 SKU 超 1500 万。",
  },
  {
    name: "深圳市前海公共安全科学研究院有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company6.webp"),
    desc: "深圳市前海公共安全科学研究院有限公司 2017 年成立，由中国工程院院士岳清瑞领衔。立足深圳，辐射大湾区，在多领域提供安全风险防控等服务。团队专业，拥多项资质与成果，秉持专业创新理念，护航城市安全重点领域。",
  },
  {
    name: "中核核信信息技术（北京）有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company8.webp"),
    desc: "中核核信信息技术（北京）有限公司 2012 年成立，系中核集团旗下企业 。深耕核工业信息技术超 40 年，定位为集团信息技术支撑总体单位。聚焦管理信息化等四大业务领域，有超 200 员工，多项专利与软著，为核工业信息化发展强力赋能。",
  },
  {
    name: "深圳市智莱科技股份有限公司",
    imgPath: require("../../assets/images/cooperativeEcosystem/company7.webp"),
    desc: "深圳市智莱科技股份有限公司成立于 1999 年，专注智能保管与交付领域，为客户提供优质产品及解决方案。公司业务遍及全球 50 多个国家和地区，拥有专利 577 项、软件著作权 193 项，通过国家高新技术企业及 ISO、CCC、CE、ETL 等多项国内外权威认证，产品远销北美、欧洲、东南亚等地。",
  },
  {
    name: "得实集团",
    imgPath: require("../../assets/images/cooperativeEcosystem/company9.webp"),
    desc: "得实集团 1988 年成立，是综合性高科技集团，业务覆盖计算机硬件、个人健康服务、LED 照明等领域。作为国内打印机头部企业，拥有 396 项知识产权，自研 SOC 芯片应用于 95% 以上自主产品，国内外设五大研发中心、研发人员约 300 人，智能卡及针式打印机国内品牌占有率第一。",
  },
]);
</script>

<style lang="scss" scoped>
.cooperativeEcosystem {
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
}

$titleSize: 2.5rem;

.title {
  color: rgba(33, 33, 33, 1);
  font-weight: 700;
  font-size: $titleSize;
  text-align: center;
}

header {
  position: relative;

  .headerImg {
    width: 100%;
    height: 100%;
  }

  margin-top: 40px !important;

  .headerTitle {
    position: absolute;
    left: 17%;
    top: 30%;
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: bold;
    font-size: 40px;
    color: #212121;
  }

  .btn {
    position: absolute;
    left: 17%;
    top: 58%;
    width: 97px;
    height: 37px;
    background: #32a89e;
    border-radius: 8px 8px 8px 8px;
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 37px;
    cursor: pointer;
  }
}

header,
main {
  margin-top: 75px;

  .topIcons {
    margin-top: 48px;
    display: flex;
    justify-content: space-around;

    .iconItem {
      width: 14%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .iconImg {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .IconIcon {
        width: 48px;
        height: 48px;
      }

      .iconTitle {
        color: #424242;
        margin: 16px 0px;
        font-weight: 700;
        font-size: 16px;
      }

      .iconContent {
        color: #888888;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
}

main {
  width: 80%;
  margin: 0 auto;

  .topIcons {
    .iconItem {
      width: 25%;
      text-align: center;
    }
  }
}

footer {
  margin-top: 72px;
  background-image: url("@/assets/images/bg/ecosystem.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .inner {
    width: 75%;
    margin: 0 auto;
    padding-top: 10px;

    .friends {
      margin-top: 24px;
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;

      .friendItem {
        width: 30%;
        height: 388px;
        margin-bottom: 32px;

        .f-img {
          width: 100%;
          height: 200px;

          .friendImg {
            width: 100%;
            height: 200px;
            box-sizing: border-box;

            &:hover {
              transform: scale(1.1);
              transition: all 1s ease-in-out;
            }
          }
        }

        .f-title {
          color: #424242;
          font-size: 16px;
          font-weight: 700;
          margin: 13px 0px;
          padding: 0px 16px;
        }

        .f-desc {
          color: #888888;
          font-weight: 500;
          font-size: 14px;
          padding: 0px 16px;
        }

        .el-card {
          border-radius: 16px;
          height: 388px;

          :deep(.el-card__body) {
            padding: 0px;
          }
        }
      }
    }
  }
}

@media (max-width: 1500px){
  .friendItem{
    height: 370px !important;

    .f-img {
      height: 150px !important;

      .friendImg {
        height: 150px !important;
      }
    }

    .el-card{
      height: 370px !important;
    }
  }


}
</style>
